import { render, staticRenderFns } from "./FactorGasSpeciesBlock.vue?vue&type=template&id=0abefaf2&scoped=true"
import script from "./FactorGasSpeciesBlock.vue?vue&type=script&lang=js"
export * from "./FactorGasSpeciesBlock.vue?vue&type=script&lang=js"
import style0 from "./FactorGasSpeciesBlock.vue?vue&type=style&index=0&id=0abefaf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abefaf2",
  null
  
)

export default component.exports